import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat min-h-screen flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/2491c77dc18b4f8ec5f84580a075522b.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Strategic Consulting for Financial Services
            </h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Expert guidance for banks, insurers, and fintechs. Navigate regulatory landscapes and execute strategic transformations with confidence.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/services">
                <Button size="lg" className="bg-blue-600 hover:bg-blue-700">
                  Explore Our Services
                </Button>
              </Link>
              <Link to="/contact">
                <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-gray-900">
                  Get Consultation
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our IGNITE Services</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive solutions designed to accelerate your financial services transformation
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shield-check-fill text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">IGNITE REGULATORY</h3>
              <p className="text-gray-600 mb-6">
                CaaS (Compliance as a Service) - subscription-based advisory service providing continuous regulatory monitoring and implementation support for EU financial institutions.
              </p>
              <ul className="text-sm text-gray-600 space-y-2 mb-6">
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>Monthly regulatory briefing</li>
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>Compliance roadmap</li>
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>PR communications briefs</li>
              </ul>
              <Link to="/services">
                <Button variant="outline" className="w-full">Learn More</Button>
              </Link>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-rocket-fill text-3xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">IGNITE EXECUTION</h3>
              <p className="text-gray-600 mb-6">
                6-week PMO Kickstart program to set up or strengthen your program management capabilities and drive transformation impact.
              </p>
              <ul className="text-sm text-gray-600 space-y-2 mb-6">
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>6-week program setup</li>
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>PMO framework &amp; toolkit</li>
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>Team training &amp; coaching</li>
              </ul>
              <Link to="/services">
                <Button variant="outline" className="w-full">Learn More</Button>
              </Link>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-rocket-2-fill text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">IGNITE LAUNCH</h3>
              <p className="text-gray-600 mb-6">
                4-week Product Launch Fast Track to accelerate your time-to-market. From concept to go-live roadmap for new financial products and services.
              </p>
              <ul className="text-sm text-gray-600 space-y-2 mb-6">
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>Product positioning &amp; fit</li>
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>Go-to-market strategy</li>
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>Launch roadmap &amp; RACI</li>
              </ul>
              <Link to="/services">
                <Button variant="outline" className="w-full">Learn More</Button>
              </Link>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-user-heart-fill text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">IGNITE CX</h3>
              <p className="text-gray-600 mb-6">
                3-week Digital Journey Diagnostic for banks, insurers, and fintechs to improve customer experience and digital performance.
              </p>
              <ul className="text-sm text-gray-600 space-y-2 mb-6">
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>3-week sprint delivery</li>
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>Digital journey assessment</li>
                <li className="flex items-center"><i className="ri-check-line text-green-500 mr-2"></i>Customer experience focus</li>
              </ul>
              <Link to="/services">
                <Button variant="outline" className="w-full">Learn More</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Why Choose Stratis Advisory?</h2>
              <p className="text-lg text-gray-600 mb-8">
                With deep expertise in financial services and regulatory compliance, we provide strategic guidance that drives real results.
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-bank-fill text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Financial Services Expertise</h3>
                    <p className="text-gray-600">Specialized knowledge in banking, insurance, and fintech sectors with proven track record.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-time-fill text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Rapid Implementation</h3>
                    <p className="text-gray-600">Fast-track your projects with our structured 3-6 week delivery timelines.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-user-star-fill text-2xl text-purple-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Agile & Flexible</h3>
                    <p className="text-gray-600">Direct access to expert consultant without corporate overhead. Tailored solutions that adapt quickly to your specific needs and timeline.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20business%20consultant%20working%20with%20financial%20data%2C%20modern%20office%20environment%2C%20charts%20and%20graphs%20on%20screens%2C%20strategic%20planning%20session%2C%20professional%20atmosphere%2C%20clean%20corporate%20setting%2C%20technology%20integration&width=600&height=400&seq=why-choose&orientation=landscape"
                alt="Professional consulting services"
                className="rounded-xl shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-purple-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to Transform Your Financial Services?</h2>
          <p className="text-xl text-purple-100 mb-8 max-w-3xl mx-auto">
            Let&#39;s discuss how our IGNITE services can help you navigate regulatory challenges and execute strategic initiatives successfully.
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-purple-900 text-white hover:bg-purple-800 whitespace-nowrap">
              Schedule a Consultation
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
